/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetClientDto } from './GetClientDto';
import {
    GetClientDtoFromJSON,
    GetClientDtoFromJSONTyped,
    GetClientDtoToJSON,
} from './GetClientDto';
import type { GetCompanyDto } from './GetCompanyDto';
import {
    GetCompanyDtoFromJSON,
    GetCompanyDtoFromJSONTyped,
    GetCompanyDtoToJSON,
} from './GetCompanyDto';
import type { GetQuestionDto } from './GetQuestionDto';
import {
    GetQuestionDtoFromJSON,
    GetQuestionDtoFromJSONTyped,
    GetQuestionDtoToJSON,
} from './GetQuestionDto';

/**
 * 
 * @export
 * @interface GetSurveyForClientDto
 */
export interface GetSurveyForClientDto {
    /**
     * 
     * @type {string}
     * @memberof GetSurveyForClientDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GetSurveyForClientDto
     */
    systemNumber: number;
    /**
     * 
     * @type {string}
     * @memberof GetSurveyForClientDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetSurveyForClientDto
     */
    nameEn: string;
    /**
     * 
     * @type {GetClientDto}
     * @memberof GetSurveyForClientDto
     */
    client: GetClientDto;
    /**
     * 
     * @type {Array<GetQuestionDto>}
     * @memberof GetSurveyForClientDto
     */
    questions: Array<GetQuestionDto>;
    /**
     * 
     * @type {GetCompanyDto}
     * @memberof GetSurveyForClientDto
     */
    company?: GetCompanyDto;
    /**
     * 
     * @type {string}
     * @memberof GetSurveyForClientDto
     */
    language: GetSurveyForClientDtoLanguageEnum;
}


/**
 * @export
 */
export const GetSurveyForClientDtoLanguageEnum = {
    Pl: 'PL',
    En: 'EN'
} as const;
export type GetSurveyForClientDtoLanguageEnum = typeof GetSurveyForClientDtoLanguageEnum[keyof typeof GetSurveyForClientDtoLanguageEnum];


/**
 * Check if a given object implements the GetSurveyForClientDto interface.
 */
export function instanceOfGetSurveyForClientDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "systemNumber" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "nameEn" in value;
    isInstance = isInstance && "client" in value;
    isInstance = isInstance && "questions" in value;
    isInstance = isInstance && "language" in value;

    return isInstance;
}

export function GetSurveyForClientDtoFromJSON(json: any): GetSurveyForClientDto {
    return GetSurveyForClientDtoFromJSONTyped(json, false);
}

export function GetSurveyForClientDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSurveyForClientDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'systemNumber': json['systemNumber'],
        'name': json['name'],
        'nameEn': json['nameEn'],
        'client': GetClientDtoFromJSON(json['client']),
        'questions': ((json['questions'] as Array<any>).map(GetQuestionDtoFromJSON)),
        'company': !exists(json, 'company') ? undefined : GetCompanyDtoFromJSON(json['company']),
        'language': json['language'],
    };
}

export function GetSurveyForClientDtoToJSON(value?: GetSurveyForClientDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'systemNumber': value.systemNumber,
        'name': value.name,
        'nameEn': value.nameEn,
        'client': GetClientDtoToJSON(value.client),
        'questions': ((value.questions as Array<any>).map(GetQuestionDtoToJSON)),
        'company': GetCompanyDtoToJSON(value.company),
        'language': value.language,
    };
}

